import { customizeError } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { getTaxAnnotationsSii } from '../../services/sii'

export const GET_TAX_ANNOTATION = 'GET_TAX_ANNOTATION'
export const GET_TAX_ANNOTATION_ERROR = 'GET_TAX_ANNOTATION_ERROR'
export const GET_TAX_ANNOTATION_SUCCESS = 'GET_TAX_ANNOTATION_SUCCESS'
export const onGetTaxAnnotationSection = makeActionCreator(GET_TAX_ANNOTATION)
export const onGetTaxAnnotationError = makeActionCreator(GET_TAX_ANNOTATION_ERROR, 'payload')
export const onGetTaxAnnotationSuccess = makeActionCreator(GET_TAX_ANNOTATION_SUCCESS, 'payload')
export const onGetTaxAnnotationsThunk = payload => async dispatch => {
  dispatch(onGetTaxAnnotationSection())

  try {
    const { data } = await getTaxAnnotationsSii({ actionType: GET_TAX_ANNOTATION, dni: payload.dni })

    return dispatch(
      onGetTaxAnnotationSuccess({
        annotations: data?.payload?.anotaciones.map(annotation => {
          return {
            annotationTitle: annotation.titulo,
            annotationReasons: annotation.descripcion
          }
        }),
        error: undefined
      })
    )
  } catch (error) {
    // FIXME: this checks should goes inside the factoryService implementation.
    // It will be fixed in v2 of react-kit.
    if (error?.originalError?.code === 'ERR_CANCELED') {
      return
    }

    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      case 403:
        // A 403 error means that the token is public or that it's a seller trying to access information that it can not see
        reason = 'FORBIDDEN_ERROR'
        break
      case 404:
        reason = 'DNI_DOES_NOT_MATCH_ERROR'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }

    return dispatch(
      onGetTaxAnnotationError({
        error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
      })
    )
  }
}
